/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdmitStorefrontCheckoutRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {AdmitStorefrontCheckoutResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const admitStorefrontCheckout = (request: AdmitStorefrontCheckoutRequest, options?: CashRequestOptions) => post<AdmitStorefrontCheckoutRequest, AdmitStorefrontCheckoutResponse>("/2.0/cash/admit-storefront-checkout", request, {...options, rejectOnError: true })